const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://universe-backend-xskf.onrender.com/api";

export const SERVER_BASE_URL =
  process.env.REACT_APP_SERVER_BASE_URL || "https://universe-backend-xskf.onrender.com";

export default API_BASE_URL;
